module.exports = __webpack_public_path__ + "png/payment-way1.png?349968e53c72febe9357d8e9612c83e1";